import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Swiper from 'react-id-swiper/lib/custom';
import Waypoint from 'react-waypoint';
import HeroSwiperSlide from './HeroSwiperSlide';
import BgImage from './../dom-elements/BgImage';
import ReactPlayer from 'react-player';
import { breakpoints } from './../../styles/theme.json';

class HeroSwiper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playing: false
    };
    this._wayPointEnter = this._wayPointEnter.bind(this);
    this._wayPointLeft = this._wayPointLeft.bind(this);
    this._slideChange = this._slideChange.bind(this);
  }
  _wayPointEnter() {
    this.swiper.autoplay.start();
  }
  _wayPointLeft() {
    this.swiper.autoplay.stop();
    this._stop();
  }
  _slideChange() {
    const slideIndex = this.swiper.realIndex;
    const slideType = this.swiper.slides[slideIndex].dataset.slidetype;
    if (slideType === 'video-media-library' && (this.player != undefined)) {
      this._onPlay();
    } else {
      this._stop();
    }
  }
  _onPlay() {
    this.player.seekTo(0);
    this.setState({
      playing: true
    });
  }
  _stop() {
    if (this.state.playing) {
      setTimeout(() => {
        this.player.seekTo(0);
        this.setState({
          playing: false
        });
      }, 1750);
    }
  }
  componentDidMount() {
    this._slideChange();
  };
  render() {
    const swiperParams = {
      on: {
        slideChange: () => {
          this._slideChange();
        }
      },
      autoplay: {
        delay: 5000
      },
      pagination: {
        el: '.hero-swiper-pagination',
        type: 'bullets',
        dynamicBullets: false,
        clickable: true
      },
      navigation: {
        nextEl: null,
        prevEl: null
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 3500
    };

    const HeroSlides = this.props.slides.map((slide, i) =>
      <div className={'hero-slide'} key={i} data-slidetype={slide.media_type}>
        <HeroSwiperSlide slideData={slide}>
          {(slide.media_type === 'video-media-library') &&
            <Fragment>
              {(this.props.window_width >= breakpoints.desktop)
                ? <ReactPlayer
                    ref={node => { if (node) this.player = node.player; }}
                    url={slide.slideshow_video_media_library}
                    className='hero-player'
                    width={'100%'}
                    height={'100%'}
                    muted={true}
                    loop={true}
                    playing={this.state.playing}
                  />
                : <BgImage source={slide.slideshow_video_media_library_cover_image.small} />
              }
            </Fragment>
          }
        </HeroSwiperSlide>
      </div>
    );

    return (
      <div id={'hero-slider'} style={(this.props.height) ? { height: this.props.height } : {height: '100vh'}}>
        <Swiper {...swiperParams} ref={node => { if (node) this.swiper = node.swiper; }}>
          {HeroSlides}
        </Swiper>
        <Waypoint
          onEnter={this._wayPointEnter}
          onLeave={this._wayPointLeft}
          topOffset='50%'
        />
        <style jsx>{`
          #hero-slider {
            width: 100vw;
            position: absolute;
            top: 0;
            left: 0;
          }
          .hero-slide {
            width: 100%;
            height: 100vh;
          }
          :global(.hero-player) {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 100;
          }
          :global(video) {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          :global(.hero-swiper-pagination){
            position: absolute;
            bottom: 3rem!important;
            width: auto!important;
            padding: 0;
            list-style: none;
            text-align: right;
            left: auto!important;
            right: 3rem;
            z-index: 9000;
            height: 1.2rem;
          }
          :global(.swiper-pagination-bullet){
            border: 1px solid #fff;
            background-color: rgba(255,255,255,0);
            width: 8px;
            height: 8px;
            margin: 0 .5rem!important;
            opacity: 1!important;
          }
          :global(.swiper-pagination-bullet-active){
            background-color: rgba(255,255,255,1);
          }
        `}</style>
      </div>
    );
  };
};

export default connect(
  state => ({
    below_hero: state.scroll_state.cat_menu_wrapper,
    window_width: state.window_dimensions.window_width
  })
)(HeroSwiper);



// WEBPACK FOOTER //
// ./src/components/hero/HeroSwiper.js